import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';

export class CustomReusingStrategy implements RouteReuseStrategy {
  shouldDetach(): boolean { return false; }
  store(): void { return; }
  shouldAttach(): boolean { return false; }
  retrieve(): DetachedRouteHandle | null { return null; }
  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    current: ActivatedRouteSnapshot,
  ): boolean {
    if (future.routeConfig?.data?.reuse !== undefined) {
      return future.routeConfig.data.reuse;
    }
    return future.routeConfig === current.routeConfig;
  }
}
